import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* getIndustries(action: actionsInterfaces.IGetIndustriesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}industries`        
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.industries.setIndustries(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.GET_INDUSTRIES, getIndustries),    
  ])
}

